<template>
    <div class="detailCard">
        <div class="card-header">
            <div class="title">
                联系人信息
            </div>
            <div class="btn">
                <el-button @click="btnClick">编辑</el-button>
            </div>
        </div>
        <div>
            <div class="card-main">
                <div class="card-group">
                    <div class="card-item">
                        <span>所属公司：</span>
                        <span>{{clientName}}</span>
                    </div>
                    <div class="card-item">
                        <span>手机：</span>
                        <span>{{detailInfo.cellphone}}</span>
                    </div>
                </div>
                <div class="card-group">
                    <div class="card-item">
                        <span>部门：</span>
                        <span>{{detailInfo.dept}}</span>
                    </div>
                    <div class="card-item">
                        <span>邮箱：</span>
                        <span>{{detailInfo.email}}</span>
                    </div>
                </div>
                <div class="card-group">
                    <div class="card-item">
                        <span>岗位：</span>
                        <span>{{detailInfo.position}}</span>
                    </div>
                    <div class="card-item">
                        <span>固话：</span>
                        <span>{{detailInfo.telephone}}</span>
                    </div>
                </div>
                <div class="card-group">
                    <div class="card-item">
                        <span>职级：</span>
                        <span>{{detailInfo.level}}</span>
                    </div>
                    <div class="card-item">
                        <span>其他联系方式：</span>
                        <span>{{detailInfo.other_contact_information}}</span>
                    </div>
                </div>
                <div class="card-group">
                    <div class="card-item">
                        <span>性别：</span>
                        <span>{{detailInfo.gender}}</span>
                    </div>
                    <div class="card-item">
                        <span>是否在职：</span>
                        <span>{{ detailInfo.status=='1' ? "是":"否" }}</span>
                    </div>
                </div>
                <div class="card-item-long">
                    <span>负责事项：</span>
                    <p style="word-break: break-all;">{{detailInfo.responsible_items}}</p>
                </div>
                <div class="card-item-long">
                    <span>其他描述：</span>
                    <p style="word-break: break-all;">{{detailInfo.other_describe}}</p>
                </div>
            </div>
        </div>
        <ContactEdit v-model="contactEditDialogVisible" :contactInfoDetailForm="contactInfoDetailForm" @refresh="refresh" />
    </div>
</template>

<script>
import ContactEdit from "@/component/Client/Contact/ContactDetail/ContactEdit.vue"
import {getContactBaseinfo} from "@/api/api";
export default {
    name: "ContactDetailCard",
    props: {
        clientId: {
            required: true
        },
        contactId: {
            required: true
        },
        clientName: {
            required: true
        }
    },
    components: {
        ContactEdit
    },
    data() {
        return {
            detailInfo: null,
            contactEditDialogVisible: false,
            contactInfoDetailForm: null
        }
    },

    mounted() {
        this.refresh()
    },

    methods: {
        async getData() {
            const {respData} = await getContactBaseinfo({"client_id": this.clientId, "contact_id": this.contactId})
            this.detailInfo = respData[0]
        },

        async refresh(refreshContactName = false) {
            await this.getData()
            if (refreshContactName){
                this.$emit('refresh', refreshContactName)
            }
        },

        btnClick() {
            this.contactInfoDetailForm = Object.assign(JSON.parse(JSON.stringify(this.detailInfo)),{"client_id": this.clientId, "contact_id": this.contactId})
            this.contactEditDialogVisible = true
        }
    }

}
</script>

<style scoped>
  .detailCard{
    /* width: 55%; */
    width: 100%;
    padding: 30px;
    box-shadow:0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  .title{
    font-weight: bold;
    font-size:18px
  }
  .card-header{
    display: flex;
    justify-content: space-between;
  }
  .card-item > span:first-child{
    display: inline-block;
    min-width: 100px;
  }
  .card-item{
    padding-top: 10px;
    width: 50%;
  }
  .card-item-long{
    padding-top: 10px;
    width: 100%;
  }
  .card-group{
      display: flex;
  }
  .card-main {
    font-size: 14px;
  }
</style>
